module.exports = __webpack_public_path__ + "media/images/mv2_bg_dummy-2a8c32e8e05cc42df860b586da990f91.png";